import api from '../api';

import { ParamsBodyUpdatePersonalData, ParamsDataUpdatePersonalData } from 'utils/typeServices';

export const PutUpdatePersonalData = async ({ body, token, tokenSent }: ParamsBodyUpdatePersonalData) => {
    const bodyAux = { ...body, NR_TOKEN: tokenSent }
    const bodyJson = JSON.stringify(bodyAux);

    try {
        const { data } = await api.put<{ mensagem: ParamsDataUpdatePersonalData }>('/v1/Cliente/AtualizarDadosPessoa', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.mensagem };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}

